export default __webpack_public_path__ + "static/media/shape1.5a3599e4.svg";